export const TEMPLATES_SIDEPANEL_ID = 'templates';
export const MY_LIBRARY_SIDEPANEL_ID = 'my_library';
export const TEMPLATES_SLIDERS_ID = 'sidepanel_templates_sliders';

const SLIDER_ACTIVE_ATTRIBUTE = 'data-moodboard--slider-active';

// The drawer's sidepanel and its rail toggle both listen for this on document.
export const openSidepanel = (sidepanelId) => {
  document.dispatchEvent(
    new CustomEvent('switch-sidepanel', { detail: { sidepanelId, active: true } })
  );
};

// Collection slides stay in the DOM once opened, so close them when we move the drawer ourselves:
// Templates should reopen on its collection list, not wherever the last pick left it.
export const resetTemplatesPanel = () => {
  document
    .querySelectorAll(`#${TEMPLATES_SLIDERS_ID} [${SLIDER_ACTIVE_ATTRIBUTE}]`)
    .forEach((slide) => slide.removeAttribute(SLIDER_ACTIVE_ATTRIBUTE));
};
